import { render, staticRenderFns } from "./modal-video.vue?vue&type=template&id=0cd2e566&scoped=true&"
import script from "./modal-video.vue?vue&type=script&lang=js&"
export * from "./modal-video.vue?vue&type=script&lang=js&"
import style0 from "./modal-video.vue?vue&type=style&index=0&id=0cd2e566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2e566",
  null
  
)

export default component.exports